import React from "react";
import Navbar from "../DashBoardComponents/Navbar";
import Footer from "../../src/DoxzonNew/Footer";
import RefundPolicyContent from "./PolicyContents/RefundPolicyContent";

function RefundPolicy() {
  return (
    <>
      <Navbar />
      <RefundPolicyContent />
      <Footer />
    </>
  );
}

export default RefundPolicy;